import React, { Component } from 'react';
import './CodeOfConduct.scss';

class CodeOfConduct extends Component {
  render() {
    return (
      <div className="wtm-coc">
        <ul className="list">
          <li className="card-group">
            <div className="card card-title">
              <h1>행동강령</h1>
            </div>
            <div className="card">
              <h3 className="major">
                WTM에서는 의사소통의 다양성을 존중하고 소속, 성별, 외모, 나이에 따른 차별을
                금지하며, 종교 및 정치적 성향들을 띄는 발언 또한 금지합니다.
              </h3>
            </div>
          </li>
          <li className="card-group">
            <div className="card">
              <h3 className="major">
                WTM에서는 연차와 개인의 능력을 가지고 서로를 판단하지 않습니다.
              </h3>
              <p className="minor">
                여러분이 진행하는 일에 제약 사항이 있다면 언제든 다른 사람들에게 도움을 청해 주세요.
                이것은 전혀 여러분의 능력 부족이 아니라 여러분 스스로의 맡은 바 책임을 다하는 것임을
                기억해 주세요.
              </p>
            </div>
            <div className="card">
              <h3 className="major">친절하게 행동해 주세요.</h3>
              <p className="minor">
                우리는 모두 같은 공동체의 일부입니다. 그러므로 다른 사람들에게 친절하게 그리고
                따듯하게 맞이하는 좋은 사람이 되어주세요. 다른 사람이 함께하고 싶어 하는 사람이
                되어주세요.
              </p>
            </div>
          </li>

          <li className="card-group">
            <div className="card">
              <h3 className="major">공손하게 행동해 주세요.</h3>
              <p className="minor">
                주위 구성원들과의 의사소통에 있어서 예의 바르고 건설적인 태도를 취하는 것을 잊지
                마세요. 비난하지 말고, 개인적인 인신공격이나 목소리를 올려 화내는 행동을 하지
                마세요. 모든 사람들은 공동체로서의 책임을 져야 하고, 서로에 대한 긴장을 완화시키고
                가능한 한 빨리 부정적인 맥락을 멈추기 위해 다 함께 노력해야 합니다.
              </p>
            </div>
            <div className="card">
              <h3 className="major">협력해주세요.</h3>
              <p className="minor">
                우리는 서로에게 많은 것을 배울 수 있습니다. 지식을 공유하고 서로서로 도와주는 환경을
                함께 만들어 주세요.
              </p>
            </div>
          </li>
          <li className="card-group">
            <div className="card">
              <h3 className="major">함께 참여해 주세요.</h3>
              <p className="minor">
                토론에 참여하고, 정기적으로 직접 만나는 모임에 참석하고, 피드백을 제공하고, 그
                피드백을 구현하는 데 도움을 주세요.
              </p>
            </div>
            <div className="card">
              <h3 className="major">온라인 토론을 위한 기본적인 에티켓을 지켜주세요.</h3>
              <p className="minor">
                한 사람에게만 공격적인 메세지를 전달하는 것을 금지합니다. 주제에서 벗어난 개인적인
                프로젝트 광고나 홍보는 스팸으로 처리합니다.
              </p>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default CodeOfConduct;
